import { MerakiSwitchStatus } from '@app/shared/models/meraki/meraki-switch-status.model';
import { Location } from '@app/shared/models/location.model';

export class MerakiLocation {
    public location: Location;
    public merakis: MerakiSwitchStatus[];
    public isLab?: boolean;
}